module.exports = __webpack_public_path__ + "img/DE00191.8e7fa060.png";